import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatTime = (dateString) => {
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid Time";
    return date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    });
  } catch (e) {
    return "Time Error";
  }
};

// Parse order string into structured items array
export const parseOrderItems = (orderString) => {
  if (!orderString || typeof orderString !== 'string') {
    return [];
  }

  const lines = orderString.split('\n').filter(line => line.trim());
  
  return lines.map(line => {
    // Format: "Name,Quantity,Price"
    const parts = line.split(',').map(p => p.trim());
    
    if (parts.length >= 2) {
      const name = parts[0];
      const quantity = parseInt(parts[1]) || 1;
      // If price is missing, default to 0
      const pricePerUnit = parseFloat(parts[2]) || 0;
      
      return {
        name,
        quantity,
        pricePerUnit,
        totalPrice: quantity * pricePerUnit
      };
    }
    
    // Fallback for simple lines
    return {
      name: line,
      quantity: 1,
      pricePerUnit: 0,
      totalPrice: 0
    };
  }).filter(item => item !== null);
};

export const calculateOrderTotal = (items) => {
  if (!Array.isArray(items)) return 0;
  return items.reduce((sum, item) => sum + (item.totalPrice || 0), 0);
};

export const calculateTotalItems = (items) => {
  if (!Array.isArray(items)) return 0;
  return items.reduce((sum, item) => sum + (item.quantity || 0), 0);
};

export const formatPrice = (price) => {
  const numPrice = typeof price === 'number' ? price : (parseFloat(price) || 0);
  // Используем ru-RU для автоматического разделения тысячных разрядов пробелом (напр. 1 000 000)
  return numPrice.toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
};